import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { TabBar, Dialog } from 'antd-mobile';
import { createFromIconfontCN } from '@ant-design/icons';
import { ApiCore } from '../../api/index';
import AeHome from '../AeHome';
import AePointsMall from '../AePointsMall';
import AeTools from '../AeTools';
import AePersonal from '../AePersonal';
import utils from '../../utils/utils';
import Menus from './menu.json';
import Author from '../../component/author'
import tab_homepage_black from '../../static/images_ae/menuIcon/tab-homepage-black.png';
import tab_homepage_gray from '../../static/images_ae/menuIcon/tab-homepage-gray.png';
import tab_activity_black from '../../static/images_ae/menuIcon/tab-activity-black.png';
import tab_activity_gray from '../../static/images_ae/menuIcon/tab-activity-gray.png';
import tab_tool_black from '../../static/images_ae/menuIcon/tab-tool-black.png';
import tab_tool_gray from '../../static/images_ae/menuIcon/tab-tool-gray.png';
import tab_personal_black from '../../static/images_ae/menuIcon/tab-personal-black.png';
import tab_personal_gray from '../../static/images_ae/menuIcon/tab-personal-gray.png';

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3398857_mcvnz8cwfxq.js'
});

const api = new ApiCore();


class AeMenuHome extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            selectedTab: 'homepage',
            hideMenu: false,
            menuArr: [],
        };
        this.closed = this.closed.bind(this)
        this.open = this.open.bind(this)
    }

    componentDidMount() {
        const urlParams = utils.getUrlParams();
        const tab = urlParams && urlParams.tab;
        tab && this.setState({
            selectedTab: tab
        });
        this.getMenus();
    }

    getMenus() {
        // api.getMenus({}, {}).then(res => {
        //     if (res.code + '' === '0') {
        //         const _data = res.data[0].children;
        //         this.setState({
        //             menuArr: _data
        //         })
        //     }
        // });
        const _data = Menus.data[0].children;
        this.setState({
            menuArr: _data
        })
    }


    updateTab(tab: any) {
        this.setState({
            selectedTab: tab
        }, () => {
            window.history.replaceState({}, '自测量表', `#/ae/home?tab=${tab}`);
        });
        document.title = '自测量表';
    }

    menusRender() {
        const { menuArr, selectedTab } = this.state;
        const existIcon = {
            'homepage': <AeHome selectedTab={selectedTab} updateTab={this.updateTab.bind(this)} />,
            'activity': <AePointsMall selectedTab={selectedTab} updateTab={this.updateTab.bind(this)} />,
            'tools': <AeTools selectedTab={selectedTab} updateTab={this.updateTab.bind(this)} />,
            'personal': <AePersonal selectedTab={selectedTab + (new Date()).getTime()} updateTab={this.updateTab.bind(this)} />
        }
        if (!menuArr || (menuArr && menuArr.length === 0)) {
            return null;
        }
        return (
            <TabBar
                unselectedTintColor="#989898"
                tintColor="#8A7AFB"
                barTintColor="white"
                hidden={this.state.hideMenu}
            >
                {menuArr.map((item: any) => {
                    let iconView = item.icon;
                    let IconComponent: any = '';
                    let _icon = tab_homepage_gray;
                    let _selectedIcon = tab_homepage_black;
                    if (item.icon === 'homepage') {
                        _icon = tab_homepage_gray;
                        _selectedIcon = tab_homepage_black;
                    } else if (item.icon === 'activity') {
                        _icon = tab_activity_gray;
                        _selectedIcon = tab_activity_black;
                    } else if (item.icon === 'tools') {
                        _icon = tab_tool_gray;
                        _selectedIcon = tab_tool_black;
                    } else if (item.icon === 'personal') {
                        _icon = tab_personal_gray;
                        _selectedIcon = tab_personal_black;
                    }
                    if (existIcon[item.icon]) {
                        IconComponent = existIcon[item.icon];
                    } else {
                        IconComponent = item.icon;
                    }
                    if (this.state.selectedTab != item.icon) {
                        IconComponent = null;
                    }
                    return (
                        <TabBar.Item
                            icon={<img src={_icon} width="20" height="20" alt="" />}
                            selectedIcon={<img src={_selectedIcon} width="20" height="20" alt="" />}
                            title={<div style={{ color: this.state.selectedTab == item.icon ? '#031CC3' : 'rgba(0,0,0,0.25)', fontSize: '13px' }}>{item.name}</div>}
                            key={item.icon}
                            selected={this.state.selectedTab === item.icon}
                            onPress={() => {
                                this.setState({
                                    selectedTab: item.icon
                                }, () => {
                                    window.history.replaceState({}, item.name, `#/ae/home?tab=` + item.icon);
                                });
                                document.title = item.name;
                            }}
                        >
                            {IconComponent}
                            {/* {
                                this.state.selectedTab == item.icon ? IconComponent : null
                            } */}
                        </TabBar.Item>
                    )
                })}
            </TabBar>
        )
    }

    closed() {
        this.setState({
            showAuthor: false
        })
    }

    open() {
        this.setState({
            showAuthor: true
        })
    }

    render() {
        return (
            <div className={`${styles.ae_menu_home_content} ${this.state.hideMenu ? styles.hide_menu_btn : ''}`}>
                {
                    this.menusRender()
                }
            </div>
        )
    };
}
export default AeMenuHome;